export class RoomType {
    refId: string;
    placeId: number;
    brandId: number | string;
    name: string;
    summary: string;
    description: string;
    code: string;
    data: any;

    constructor(dto: any) {
        this.refId = dto.ref_id;
        this.placeId = dto.place_id;
        this.brandId = dto.brand_id;
        this.name = dto.name;
        this.summary = dto.summary;
        this.description = dto.description;
        this.code = dto.code;
        this.data = dto.data;
    }

    getServerModel(): object {
        return {
            ref_id: this.refId,
            place_id: this.placeId,
            brand_id: this.brandId,
            name: this.name,
            summary: this.summary,
            description: this.description,
            code: this.code,
            data: this.data
        }
    }
}